/** @format */

export interface IProductInventory {
  atsqty: string;
  boplqty?: string;
  inventory: number;
  isaInventory: number;
  isaqty: string;
  location: string;
  sku: string;
  time: string;
}
